import { IBusinessHoursSettings } from './client';
import { BusinessHoursSettingsServer } from './server';

export const normalizeBusinessHoursSettings = (
  raw: BusinessHoursSettingsServer
): IBusinessHoursSettings => ({
  enabled: raw.enabled,
  schedule: raw.schedule.map((day) => ({
    weekday: day.weekday,
    dayOff: day.day_off,
    start: day.start,
    end: day.end
  })),
  autoReply: {
    enabled: raw.auto_reply.enabled,
    text: raw.auto_reply.text
  }
});
